"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _RenderIf = _interopRequireDefault(require("../RenderIf"));

var _styled = require("./styled");
/**
 * LoadingShape can be used to display a placeholder where content
 * is being loaded asynchronously.
 */


var LoadingShape = function LoadingShape(props) {
  var className = props.className,
      style = props.style,
      shape = props.shape,
      variant = props.variant;
  var shapeRef = (0, _react.useRef)();
  var isImage = variant === 'image';
  var isAvatar = variant === 'avatar';
  (0, _react.useEffect)(function () {
    var element = shapeRef.current;

    if (shape === 'square' || shape === 'circle') {
      element.style.width = "".concat(element.offsetHeight, "px");
    } else {
      element.style.width = '100%';
    }
  });
  return /*#__PURE__*/_react["default"].createElement(_styled.StyledShapeContainer, {
    className: className,
    style: style
  }, /*#__PURE__*/_react["default"].createElement(_styled.StyledLoadingShape, {
    shape: shape,
    variant: variant,
    ref: shapeRef
  }, /*#__PURE__*/_react["default"].createElement(_RenderIf["default"], {
    isTrue: isImage
  }, /*#__PURE__*/_react["default"].createElement(_styled.StyledImageIcon, {
    shape: shape
  })), /*#__PURE__*/_react["default"].createElement(_RenderIf["default"], {
    isTrue: isAvatar
  }, /*#__PURE__*/_react["default"].createElement(_styled.StyledAvatarIcon, {
    shape: shape
  }))));
};

LoadingShape.propTypes = {
  /** A CSS class for the outer element, in addition to the component's base classes. */
  className: _propTypes["default"].string,

  /** An object with custom style applied to the outer element. */
  style: _propTypes["default"].object,

  /** The shape of the loading placeholder */
  shape: _propTypes["default"].oneOf(['circle', 'rect', 'rounded-rect', 'square']),

  /** The variant of the loading placeholder */
  variant: _propTypes["default"].oneOf(['solid', 'image', 'avatar'])
};
LoadingShape.defaultProps = {
  className: undefined,
  style: undefined,
  shape: 'rounded-rect',
  variant: 'solid'
};
var _default = LoadingShape;
exports["default"] = _default;